import { SvgIcon, SvgIconProps } from '@mui/material';

export function SummarizedFeedbackInsightsIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 47 47" {...props}>
      <g filter="url(#filter0_d_691_59490)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.2224 8.94327L34.6605 12.3887C34.3046 13.1565 33.1974 13.1565 32.8415 12.3887L31.2796 8.92358L27.8197 7.36823C27.0487 7.01385 27.0487 5.93101 27.8197 5.57663L31.2994 4.02127L32.8613 0.575874C33.2172 -0.191958 34.3046 -0.191958 34.6605 0.575874L36.2224 4.04096L39.6823 5.59631C40.4533 5.9507 40.4533 7.03354 39.6823 7.38792L36.2224 8.94327ZM15.7792 8.45107L18.9228 15.3419L25.8426 18.4723C27.3848 19.1613 27.3848 21.3467 25.8426 22.0555L18.9228 25.1859L15.7792 32.0767C15.0873 33.6123 12.8927 33.6123 12.1809 32.0767L9.03736 25.1859L2.11754 22.0555C0.575405 21.3664 0.575405 19.181 2.11754 18.4723L9.03736 15.3419L12.1809 8.45107C12.8729 6.91541 15.0873 6.91541 15.7792 8.45107ZM31.2796 31.5845L32.8415 28.1391C33.1974 27.3712 34.3046 27.3712 34.6605 28.1391L36.2224 31.6042L39.6823 33.1595C40.4533 33.5139 40.4533 34.5967 39.6823 34.9511L36.2026 36.5065L34.6407 39.9519C34.2848 40.7197 33.1974 40.7197 32.8415 39.9519L31.2796 36.4868L27.8197 34.9314C27.0487 34.577 27.0487 33.4942 27.8197 33.1398L31.2796 31.5845Z"
          fill="url(#paint0_angular_691_59490)"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_691_59490"
          x="0.960938"
          y="0"
          width="42.0072"
          height="43.2377"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.35516" dy="1.35516" />
          <feGaussianBlur stdDeviation="0.67758" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.1447 0 0 0 0 0.0280685 0 0 0 0.29 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_691_59490"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_691_59490"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_angular_691_59490"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.0641 20.3274) rotate(-17.7004) scale(33.4288 22.5089)"
        >
          <stop offset="0.140021" stopColor="#FF5C00" />
          <stop offset="0.675021" stopColor="#FFA800" stopOpacity="0.53" />
        </radialGradient>
      </defs>
    </SvgIcon>
  );
}
